import { AppLayout } from "@amzn/awsui-components-console";
import React, { ReactNode, useEffect, useState } from "react";

import SideMenu from "src/components/sideMenu/SideMenu";

interface ClaimIntakeAppLayoutPageProps {
  /**
   * Document title set on mount. Lives on the page wrapper rather than
   * inside the mounted app so the chrome stays consistent regardless of
   * which LOB the user is in.
   */
  pageTitle: string;
  /**
   * Element rendered inside the `AppLayout` content slot — typically a
   * claim intake `App` component (JsonFormsClaimIntakeApp, etc.).
   */
  content: ReactNode;
}

/**
 * Shared `AppLayout` wrapper for claim-intake pages. Encapsulates the
 * Cloudscape chrome (side menu, header/footer selectors, navigation
 * toggle) so individual claim intake pages only need to specify their
 * page title and the inner app component.
 */
function ClaimIntakeAppLayoutPage({
  pageTitle,
  content,
}: ClaimIntakeAppLayoutPageProps): JSX.Element {
  const [navigationOpen, setNavigationOpen] = useState(true);

  useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  return (
    <AppLayout
      content={content}
      navigation={<SideMenu />}
      navigationOpen={navigationOpen}
      onNavigationChange={({ detail }) => setNavigationOpen(detail.open)}
      ariaLabels={{
        navigationClose: "Close side menu",
        navigationToggle: "Open Side menu",
      }}
      toolsHide={true}
      contentType="wizard"
      footerSelector="#app-footer"
      headerSelector="#app-header"
    />
  );
}

export default ClaimIntakeAppLayoutPage;
